/** Pixel size of an image file. */
export interface ImageSize {
  readonly width: number;
  readonly height: number;
}

/**
 * Reads the pixel size the browser decodes from an image file; null when it cannot read it.
 * The object URL lives only for the read.
 */
export function readImageSize(file: File): Promise<ImageSize | null> {
  return new Promise(resolve => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    const finish = (size: ImageSize | null) => {
      URL.revokeObjectURL(url);
      resolve(size);
    };
    image.onload = () =>
      finish(
        image.naturalWidth > 0 && image.naturalHeight > 0
          ? { width: image.naturalWidth, height: image.naturalHeight }
          : null
      );
    image.onerror = () => finish(null);
    image.src = url;
  });
}
